export class User {
    Id: number;
    // PUT/GET Benutzername
    Benutzer: string ;
    // PUT Kennwort, nicht zurückgegeben
    Kennwort: string ;
    // GET Vorname
    Vorname: string ;
    // Get Nachname
    Nachname: string ;
    // GET SessionToken
    SessionToken: string ;
    // Get Firmenname
    CustomerName: string;
    // Get Mandantenname
    MandantenName: string ;

    // Get Rückgebewert
    ResponseID: number;
    // Get Rückgabetext, z.B. Fehlermeldung
    ResponseMsg: string ;

    constructor() {
    }

}



// WEBPACK FOOTER //
// D:/Crossplatform/swsLagerinfo/src/app/models/user.model.ts